import React from 'react';
import RankingWorkspace from '../../components/ranking/RankingWorkspace';

function RankingPage() {
  return <RankingWorkspace pageMode="ranking" />;
}

export default RankingPage;
